import { Checkbox, FormControlLabel } from "@mui/material";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../redux/store";
import { dataBrowserSelectAllToggleAction } from "../redux/lists.actions";
interface IOwnProps {
    label?: string;
}

const SelectAll = ({ label = "Select All" }: IOwnProps) => {
    const dispatch = useDispatch();
    const { selectAll, selectedListIds } = useAppSelector(
        (state) => state.dataBrowserList,
    );

    const handleCheckboxChange = () => {
        dispatch(dataBrowserSelectAllToggleAction());
    };

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={selectAll && !selectedListIds.length}
                    onChange={handleCheckboxChange}
                />
            }
            label={label}
        />
    );
};

export default SelectAll;
